@if (dataLoaded$ | async) {
  <div class="main pad-top-30">
    <ds-kyd-smartphone-header-info
      [policy]="selectedAutoPolicy$ | async"
      [emailId]="enrollmentEmailId$ | async"
      [hasMultipleEligibleOperators]="hasMultipleEligibleKydOperators$ | async"
    ></ds-kyd-smartphone-header-info>
    <ds-kyd-smartphone-operator-table
      [operatorsData]="policyOperatorData$ | async"
      [phoneNumbers]="phoneList$ | async"
      [isPolicyEnrolled]="isPolicyEnrolled$ | async"
      [hasMultipleOperatorsEnrolled]="hasMultipleOperatorsEnrolled$ | async"
      [isPhhEligible]="isPhhEligible$ | async"
      [policyState]="policyState$ | async"
      (enrollAllOperatorsEvent)="openEnrollAllModal()"
      (unEnrollAllOperatorsEvent)="openUnenrollAllModal()"
      (enrollOneOperatorEvent)="enrollOperator($event)"
      (unEnrollOneOperatorEvent)="unenrollOperator($event)"
      (updatePhoneNumberEvent)="updateOperatorPhoneNumber($event)"
      [isKydEnrolledAndEligible]="showKYDManageEnrollmentDuringMigration$ | async"
    >
    </ds-kyd-smartphone-operator-table>
    <ds-about-know-your-drive [recentAction]="recentAction$ | async"> </ds-about-know-your-drive>
    <ds-next-steps
      [isPolicyEnrolled]="isPolicyEnrolled$ | async"
      [recentAction]="recentAction$ | async"
      [emailId]="enrollmentEmailId$ | async"
      [policyState]="policyState$ | async"
    >
    </ds-next-steps>
    <ds-kyd-smartphone-enroll-all-modal
      [operatorsData]="policyOperatorData$ | async"
      [phoneNumbers]="phoneList$ | async"
      (enrollAll)="enrollAll($event)"
      (closeModal)="closeModal($event)"
    ></ds-kyd-smartphone-enroll-all-modal>
    <ds-kyd-smartphone-unenroll-all-modal
      [policyState]="policyState$ | async"
      (unEnrollAll)="unEnrollAllOperators()"
      (closeModal)="closeModal($event)"
      [headerContentRef]="headerContentRef$ | async"
      [bodyContentRef]="bodyContentRef$ | async"
      [confirmContentRef]="confirmContentRef$ | async"
      [operators]="policyOperatorDataForUnEnroll$ | async"
    >
    </ds-kyd-smartphone-unenroll-all-modal>
  </div>
}
